<template>
  <div v-if="routeInfo.name!='user'">
    <div v-if="activeMenu!='/tiktok'" :class="{'has-logo':showLogo}" class="slideBarItem2">
      <!--      <div class="title">{{ title }}</div>-->
      <div v-if="routeInfo.name=='course'" class="title">知识店铺</div>
      <div v-else-if="routeInfo.name!='user'" class="title">概述</div>
      <el-scrollbar wrap-class="scrollbar-wrapper">
        <!--       -->
        <el-menu
          :default-active="activeMenu"
          :background-color="variables.menuBg2"
          :text-color="variables.menuText2"
          :unique-opened="false"
          :active-text-color="variables.menuActiveText2"
          :collapse-transition="false"
          mode="vertical"
        >
          <sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
        </el-menu>
      </el-scrollbar>
      <div v-if="routeInfo.name=='course'" class="title">服务店铺</div>
      <el-scrollbar v-if="routeInfo.name=='course'" wrap-class="scrollbar-wrapper" style="padding-bottom: 100px;">
        <el-menu
          :default-active="activeMenu"
          :collapse="false"
          :background-color="variables.menuBg2"
          :text-color="variables.menuText2"
          :unique-opened="false"
          :active-text-color="variables.menuActiveText2"
          :collapse-transition="false"
          mode="vertical"
        >
          <sidebar-item v-for="route in permission_routes2" :key="route.path" :item="route" :base-path="route.path" />
        </el-menu>
      </el-scrollbar>

    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem },
  data() {
    return {
      title: '数据统计', // 标题
      permission_routes2: [{ path: '/course/list?shopDict=2&bizDict=1', meta: { title: '单个服务' }, title: '单个服务' },
        { path: '/course/list?shopDict=2&bizDict=4', meta: { title: '关联产品' }, title: '关联产品' },
        { path: '/course/list?shopDict=2&bizDict=100', meta: { title: '下载类内容' }, title: '下载类内容' }

        // &&mediaDict=5
        // { path: '/course/list?shopDict=1&bizDict=7', meta: { title: '套餐' }, title: '套餐' }
      ], // 兼职店铺
      permission_routes: []
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters([
      // 'permission_routes',
      'sidebar'
    ]),
    activeMenu() {
      this.permission_routes = this.$route.matched[1].meta.childList
      this.title = this.$route.meta.title
      const route = this.$route

      // const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      // if (meta.activeMenu) {
      //   return meta.activeMenu
      // }
      return route.fullPath
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    routeInfo() {
      return this.$route
    },
    isCollapse() {
      // return !this.sidebar.opened
    }
  }
}
</script>

<style lang="scss" scoped>
  .slideBarItem2::v-deep{
    left: 170px;
    overflow-y: auto;
    height: 100vh;
    &::-webkit-scrollbar { width: 0 !important }
    .el-scrollbar{
      height: auto!important;
      &::-webkit-scrollbar { width: 0 !important }
    }
    .title{
      padding-left: 30px!important;
      font-size: 16px;
      color: #000;
      font-weight: bolder;
      line-height: 56px;
      padding-top:60px;
    }
    .is-active{
      /*background: rgba(247, 249, 250, 1);*/
    }
    .el-menu-item{
      font-size: 13px;
      padding-left: 30px!important;
      /*font-weight: bolder;*/
      background: rgba(247, 249, 250, 1)!important;
      &:hover{
        background: rgba(247, 249, 250, 1)!important;
      }
    }
  }

</style>
